import { useSelector } from 'react-redux'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import {
  SENTIMENT_COLOR_BY_ID,
  SENTIMENT_ICON_BY_ID,
} from '../../common/constant'
import { selectAlertById } from '../store/slice'

export const TypeDescription = ({ rowId }) => {
  const { sentimentId, alertCriteriaName, alertDesc } = useSelector(
    selectAlertById(rowId),
  )

  const color = SENTIMENT_COLOR_BY_ID[sentimentId]

  return (
    <Element className="dFlex">
      <Element>
        <Icon
          className={SENTIMENT_ICON_BY_ID[sentimentId]}
          style={{ fontSize: 13, color, marginRight: 3 }}
        />
      </Element>
      <Element>
        <Element style={{ color }}>{alertCriteriaName}</Element>
        <Element>{alertDesc}</Element>
      </Element>
    </Element>
  )
}
